<template>
  <div>
    <TopNavBar></TopNavBar>
    <router-view></router-view>
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar.vue";
export default {
  components: {
    TopNavBar,
  },
};
</script>
